import { ValidatorFn, AbstractControl } from "@angular/forms";
import { OrganizationStub } from "../../common/models/organization.model";

export enum OnBehalfSteps {
    SelectSubmission,
    SelectOrganization,
    GenerateApplicationNumber,
    GenerateScanAndSubmit
}

export interface InitializeOnBehalfSpec {
    workflowTemplateId: string;
    onBehalfOrganizationId: string;
    initiatingUserId?: string;
    initiatingUserName?: string;
    instanceIdentifier: string;
}


